import React from 'react';
import { BRAND } from '../../brand.js';

const B = BRAND.blocks;
// A 3×5 grid of 34-unit blocks with a 4-unit gutter — the "b" of the mark.
const CELL = 34;
const STEP = 38;
const R = 9;
const x = (col) => col * STEP;
const y = (row) => row * STEP;

/**
 * The BrickBiyte block mark as inline SVG, so it is crisp at any size and needs
 * no asset pipeline. `size` is the rendered height in px; width follows.
 */
export function BrandMark({ size = 28, className = '', title = BRAND.name }) {
  const height = size;
  const width = Math.round((size * 110) / 186);
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 110 186"
      role="img"
      aria-label={title}
      focusable="false"
    >
      <rect x={x(0)} y={y(0)} width={CELL} height={CELL} fill={B.crimson} />
      <rect x={x(0)} y={y(1)} width={CELL} height={CELL} fill={B.orange} />
      <rect x={x(1)} y={y(2)} width={CELL} height={CELL} fill={B.magenta} />
      {/* Yellow: rounded top-right corner. */}
      <path
        d={`M${x(2)} ${y(2)} h${CELL - R} a${R} ${R} 0 0 1 ${R} ${R} v${CELL - R} h-${CELL} z`}
        fill={B.yellow}
      />
      <rect x={x(2)} y={y(3)} width={CELL} height={CELL} fill={B.green} />
      {/* Lime: rounded bottom-left corner. */}
      <path
        d={`M${x(0)} ${y(4)} h${CELL} v${CELL} h-${CELL - R} a${R} ${R} 0 0 1 -${R} -${R} z`}
        fill={B.lime}
      />
      <rect x={x(1)} y={y(4)} width={CELL} height={CELL} fill={B.blue} />
      {/* Purple: rounded bottom-right corner. */}
      <path
        d={`M${x(2)} ${y(4)} h${CELL} v${CELL - R} a${R} ${R} 0 0 1 -${R} ${R} h-${CELL - R} z`}
        fill={B.purple}
      />
    </svg>
  );
}

/** Mark + wordmark, for the navbar and the sign-in screen. */
export function BrandLockup({ size = 28, className = '' }) {
  return (
    <span className={`brand-lockup d-inline-flex align-items-center ${className}`.trim()}>
      <BrandMark size={size} className="brand-lockup-mark me-2" title="" />
      <span className="brand-lockup-name">{BRAND.name}</span>
    </span>
  );
}

/** The cover's eight-colour stripe. */
export function BrandStripe({ className = '' }) {
  return <span className={`brand-stripe ${className}`.trim()} aria-hidden="true" />;
}

export default BrandMark;
